const screenTooSmallLocales = {
  message: {
    ar: "هذه الشاشة صغيرة جدًا لعرض المحتوى بشكل صحيح. يرجى تكبير الشاشة أو استخدام جهاز أكبر.",
    en: "This screen is too small to display the content properly. Please enlarge the screen or use a larger device.",
  },
};

export default screenTooSmallLocales;
